fragment flexibleDeadlines on flexibleSections_deadlines_BlockType {
    __typename
    singleSubsidyRelation {
        id
    }
}
